import {helpers} from 'vuelidate/lib/validators'

/* eslint-disable-next-line */
export const email = helpers.regex('alpha', /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/)

export const phone = helpers.regex('alpha', /^\+375 \((17|25|29|33|44)\) [0-9]{3} [0-9]{4}$/)

export const alphaNumAndLetter = helpers.regex('alphaNumAndDot', /^[a-zA-Z\d]*$/i)
